/**
 * Prefer runtime config (Dokploy / Docker env → /env-config.js),
 * fall back to Vue CLI build-time process.env for local `npm run serve`.
 */
export function getEnv(key) {
  if (
    typeof window !== "undefined" &&
    window.__ENV__ &&
    typeof window.__ENV__[key] === "string" &&
    window.__ENV__[key].length > 0
  ) {
    return window.__ENV__[key];
  }
  const value = process.env[key];
  return typeof value === "string" ? value : "";
}
